/*
 * @Descripttion:
 * @version:
 * @Author: ZhangChao
 * @Date: 2022-06-24 14:50:20
 * @LastEditors: ZhangChao
 * @LastEditTime: 2023-03-06 20:09:30
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    meta: { main: true, requireAuth: false }
  },
  {
    path: '/login/:route',
    meta: { requireAuth: false },
    component: () => import(/* webpackChunkName: "home" */ '../views/login/index.vue')
  },
  {
    path: '/login',
    meta: { requireAuth: false },
    component: () => import(/* webpackChunkName: "home" */ '../views/login/index.vue')
  },
  {
    path: '/home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/main.vue'),
    redirect: '/home/index',
    children: [{
      path: '/home/index',
      component: () => import(/* webpackChunkName: "home" */ '../views/home/index.vue')
      // redirect: '/yunkt/myres'
    }]
  },
  {
    path: '/fxzl',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/main.vue'),
    redirect: '/fxzl/gjzw',
    children: [{
      path: '/fxzl/gjzw',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/gjzw.vue')
    }, {
      path: '/fxzl/sbss',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/sbss.vue')
    }, {
      path: '/fxzl/tzsb',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/tzsb.vue')
    }, {
      path: '/fxzl/hxp',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/hxp.vue')
    }, {
      path: '/fxzl/yxkj',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/yxkj.vue')
    }, {
      path: '/fxzl/yhsjk',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/yhsjk.vue')
    }, {
      path: '/fxzl/fxbs/:unitId/:unitType',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/fxbs.vue')
    }, {
      path: '/fxzl/flfg',
      component: () => import(/* webpackChunkName: "home" */ '../views/fxzl/flfg.vue')
    }]
  },
  {
    path: '/yhpc',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/main.vue'),
    redirect: '/yhpc/xmlist',
    children: [{
      path: '/yhpc/xmlist',
      component: () => import(/* webpackChunkName: "home" */ '../views/yhpc/xmlist.vue')
    }, {
      path: '/yhpc/loglist',
      component: () => import(/* webpackChunkName: "home" */ '../views/yhpc/loglist.vue')
    }]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
